// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { PaginationModel, StateModel } from "@insite/client-framework/Types/ApiModels";

const allEventsRequestUrl = "/api/serc/allEvents";
const eventRegistrationUrl = "/api/serc/eventRegister";

export interface EventModel {
    city: string;
    eventAddress: string;
    eventCourseCode: string;
    eventCourseDescription: string;
    eventStartDate: string;
    eventEndDate: string;
    eventStartTime: string;
    eventEndTime: string;
    eventImage: string;
    eventLocation: string;
    eventPrice?: string;
    eventRichContent: string;
    eventTitle: string;
    eventType: string;
    id: string;
    postalCode: string;
    registration: boolean;
    registrationUrl?: string;
    state: string;
    streetAddress: string;
    url: string;
}

export interface AllEventsModel {
    events: EventModel[];
    pagination?: PaginationModel;
}

export interface AllEventsApiParameter extends ApiParameter, HasPagingParameters {
    eventType?: string;
    location?: string;
    reset?: string;
    minDate?: string;
    onlyUpcomingEvents?: boolean;
    sortOnField?: string;
    sortDescending?: boolean;
}

export interface EventTypeApiParameter extends ApiParameter, HasPagingParameters {
    location?: string;
}
export interface EventRegistrationApiParameter extends ApiParameter {
    firstName?: string;
    lastName?: string;
    title?: string;
    company?: string;
    streetAddress1?: string;
    streetAddress2?: string;
    city?: string;
    state?: string;
    postalCode: string;
    companyPhone?: string;
    mobilePhone: string;
    email?: string;
    poNumber: string;
    comments: string;
    eventUrlSegment: string;
    howToContact: string;
}

export async function getAllEventsRequest(parameter: AllEventsApiParameter) {
    const allEvents = await get<AllEventsModel>(`${allEventsRequestUrl}/getEvents`, parameter);
    allEvents?.events?.forEach(event => {
        event.id = event.url;
    });
    return allEvents;
}

export async function getEventTypes(parameter: EventTypeApiParameter) {
    if (!parameter.location) {
        const eventTypes = await get<string[]>(`${allEventsRequestUrl}/eventTypes`);
        return eventTypes;
    }
    const eventTypes = await get<string[]>(`${allEventsRequestUrl}/eventTypes/${parameter.location}`);
    return eventTypes;
}

export async function getEventLocations() {
    const eventLocations = await get<string[]>(`${allEventsRequestUrl}/eventLocations`);
    return eventLocations;
}

export async function postEventRegistration(parameter: EventRegistrationApiParameter) {
    const eventRegister = await post<EventRegistrationApiParameter>(`${eventRegistrationUrl}`, parameter);
    return eventRegister;
}
